import{__exports as e}from"../../../../_virtual/camelToHyphen.js";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(e){return e.replace(/[A-Z]/g,(function(e){return"-"+e.toLowerCase()})).toLowerCase()};
//# sourceMappingURL=camelToHyphen.js.map
